//@ts-nocheck 
export default function BannerHeadline({ title, textAlign = "left", width = 100, useCase = "other" }) {
    return (<>
        {title && useCase === "other" && (
            <div className='banner-headlines' style={{ textAlign: textAlign, width: `${width}%` }}>{title}</div>
        )}
        {title && useCase === "hero" && (
            <h1 className='banner-headlines' style={{ textAlign: textAlign, width: `${width}%` }}>{title}</h1>
        )}
    </>)
}